/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable object-curly-newline */
import { Route, Switch, useRouteMatch } from 'react-router';
import { urls } from '../../../Constants';
import { OrdersHistory } from '../../../Pages';

const getSubURL = (entity) => {
	const baseEntity = urls.COOKING_ANALYSIS;
	return entity.slice(baseEntity.length);
};
const OrdersHistoryRoutes = () => {
	const { path } = useRouteMatch();
	return (
		<div>
			<Switch>
				<Route
					path={`${path}${getSubURL(urls.COOKING_ANALYSIS_LIST)}`}
					exact
				>
					<OrdersHistory />
				</Route>
			</Switch>
		</div>
	);
};

export default OrdersHistoryRoutes;
